import { useParams } from 'react-router-dom';

import { QueueContent } from './ui/QueueContent';

/** Страница очереди: шапка и задачи с быстрыми фильтрами */
const QueuePage = () => {
  const { queueKey = '' } = useParams();

  // key: при переходе в другую очередь — новый стор, без остатков фильтров прошлой
  return <QueueContent key={queueKey} queueKey={queueKey} />;
};

export { QueuePage };
